import React, { useContext, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import ButtonGroup from "components/Reusables/ButtonGroup";
import { createCheckout } from "utils/Shopify";
import { CartContext, UserContext } from "contexts/";
import GTM from "utils/GTM";
import LoginButton from "@components/Reusables/LoginButton";
// import userApi from "../../utils/api/UserApi";

function CheckOutButton(props) {
	const { getAccessTokenSilently, loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

	const { localCart, setLocalCart, cartItems } = useContext(CartContext);
	const { user, userData, userApi } = useContext(UserContext);

	const [spinner, setSpinner] = useState(false);

	let cart = props.variantId ? { [props.variantId]: { quantity: 1 } } : localCart;

	if (!user) {
		return <LoginButton additionalClasses="px-4" fontSize="16" text="Please log in or register to checkout" />;
	}

	return (
		<ButtonGroup
			additionalClasses={"px-4"}
			buttonWidth={props.buttonWidth}
			myRef={props.myRef}
			title={props.title}
			onClick={async () => {
				setSpinner(true);
				let _cartItems = props.cartItemsOverRide ? Object.values(props.cartItemsOverRide) : cartItems;

				GTM.checkout(_cartItems, userData);

				if (props.onClick) {
					try {
						await props.onClick();
					} catch (err) {
						setSpinner(false);

						alert(
							"Sorry, an error occurred. Please contact customerservice@physicianleaders.org if this issue continues."
						);
						return new Error(err);
					}
				}
				try {
					const checkoutUrl = await createCheckout(props.cart || cart);
					if (checkoutUrl) {
						// setLocalCart({});//this is not good in this case, shows a flash of an empty cart right as the user is checking out
						//clears local storage without updating state

						try {
							//get multipass url
							const token = await getAccessTokenSilently();

							const multipassUrl = await userApi.getMultipass(checkoutUrl, token);

							localStorage.setItem(process.env.CART_LOCAL_STORAGE_NAME, JSON.stringify({}));

							window.location = multipassUrl;
						} catch (err) {
							console.error(err);
							throw err;
						}
						// window.location = checkout.webUrl;
						//TODO update the cart items after they have been purchased
					} else {
						setSpinner(false);
						console.error("An error must have occurred");
						alert("Sorry an error occurred.  Please contact customerservice@physicianleaders.org");
						throw "err";
					}
				} catch (err) {
					console.error(err);
				}
			}}
			alignButtons={props.align ? props.align : "end"}
			aria-label="checkout-products"
			btn1={{
				text: props.text ? props.text : `Check Out`,
			}}
			button1Variant={props.btnVariant ? props.btnVariant : "yellow"}
			isDisabled={
				props.disabled
					? true
					: spinner
					? true
					: props.cart
					? false
					: props.variantId
					? false
					: cartItems.length == 0
					? true
					: false
			}
			button1Children={
				spinner ? (
					<FontAwesomeIcon icon={faSpinner} className="w-20px ms-2 d-inline spin" />
				) : (
					<FontAwesomeIcon icon={faArrowRight} className="w-20px ms-2 d-inline" />
				)
			}
		></ButtonGroup>
	);
}

export default CheckOutButton;

("[{errorCode:NOT_FOUND,message:Provided external ID field does not exist or is not accessible: 00000000-0000-0000-0000-000000000000}]");
